var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simplebar',{staticClass:"prosemirror-wrapper"},[_c('editor-content',{staticClass:"tiptap-editor",attrs:{"editor":_vm.editor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }